import { Icon } from "./Icon";
export const IconStar = (props) => (
  <Icon {...props} viewBox="0 0 11.41 10.86">
    <path d="M5.71,0,7.47,3.57l3.94.58L8.56,6.93l.67,3.93L5.71,9,2.18,10.86l.67-3.93L0,4.15l3.94-.58Z"/>
  </Icon>
);
